import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { StepNavItem } from '../step-nav/step-nav.component';

export type ReduceStep = 'solutions' | 'action-plan';

/**
 * The two steps of the simplified reduction, shown above the Solutions and Action plan pages:
 * pick solutions, then follow them up in the action plan. Either step can be opened whenever needed.
 */
@Component({
    selector: 'app-reduce-steps',
    templateUrl: './reduce-steps.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ReduceStepsComponent {
    @Input({ required: true }) active!: ReduceStep;

    readonly steps: StepNavItem[] = [
        { id: 'solutions', label: 'menu.app.solutions', route: '/app/solutions' },
        { id: 'action-plan', label: 'menu.app.actionPlan', route: '/app/actionplan' },
    ];
}
